import { render, staticRenderFns } from "./motivate.vue?vue&type=template&id=57dde94f&"
import script from "./motivate.vue?vue&type=script&lang=js&"
export * from "./motivate.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports